module.exports = __webpack_public_path__ + "static/media/download~bjCODHXh.02e9c647.svg";